import loader from '../moduleLoader';

class Main {
    constructor(main) {
        this.main = main;
        this.footer = document.querySelector('.footer-v2');
    }
    init() {
        this.main.style.minHeight = (window.innerHeight - this.footer.offsetHeight) + 'px';
    }
}

loader.add('Main', Main);

export default Main;